import React from "react";
import PropTypes from "prop-types";

const Deedle = ({ term, definition }) => (
  <dl style={styles.dl}>
    <dt style={styles.dt}>{term}</dt>
    <dd style={styles.dd}>{definition}</dd>
  </dl>
);

Deedle.propTypes = {
  term: PropTypes.string,
  definition: PropTypes.any,
};

const styles = {
  dl: {
    marginTop: 10,
    marginBottom: 10,
  },
  dt: {
    fontWeight: "700",
    marginBottom: 5,
  },
  dd: {},
};

export default Deedle;
